import { render, staticRenderFns } from "./RDetailSkeleton.vue?vue&type=template&id=580b44e0&scoped=true"
import script from "./RDetailSkeleton.vue?vue&type=script&lang=js"
export * from "./RDetailSkeleton.vue?vue&type=script&lang=js"
import style0 from "./RDetailSkeleton.vue?vue&type=style&index=0&id=580b44e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580b44e0",
  null
  
)

export default component.exports